import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/findAllForOrderReportFilter`;

export const ROUTE: RouteDefinition = `${baseRoute}/findAllForOrderReportFilter`;

export const URL = (): RouteDefinition => `${baseRoute}/findAllForOrderReportFilter`;
